import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/react-query';
import { StatisticsApi } from 'api';

/**
 * [Statistics] Query key 생성
 * --
 */
export const statisticsQueryKeys = createQueryKeys('statistics', {
  getStatistics: (type, params) => [type, params],
});

/**
 * [Statistics] 스태프 전체 조회
 * --
 */
export const useGetStatisticsSummary = (type, params, options) => {
  const data = useQuery({
    queryKey: statisticsQueryKeys.getStatistics(type, params).queryKey,
    queryFn: () => StatisticsApi.getStatisticsSummary(type, params),
    ...options,
  });
  return data;
};
